const UnlockUser = () => {
  return (
    <svg width='56' height='56' viewBox='0 0 56 56' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='4' y='4' width='48' height='48' rx='24' fill='#F9E1DD' />
      <rect x='4' y='4' width='48' height='48' rx='24' stroke='#FBEBE8' strokeWidth='8' />
      <g clipPath='url(#clip0_15864_73079)'>
        <path
          d='M28 28C26.9 28 26 28.9 26 30C26 31.1 26.9 32 28 32C29.1 32 30 31.1 30 30C30 28.9 29.1 28 28 28ZM34 23H33V21C33 18.24 30.76 16 28 16C25.72 16 23.73 17.54 23.16 19.75C23.02 20.29 23.34 20.83 23.88 20.97C24.41 21.11 24.96 20.79 25.1 20.25C25.44 18.93 26.63 18 28 18C29.65 18 31 19.35 31 21V23H22C20.9 23 20 23.9 20 25V35C20 36.1 20.9 37 22 37H34C35.1 37 36 36.1 36 35V25C36 23.9 35.1 23 34 23ZM34 34C34 34.55 33.55 35 33 35H23C22.45 35 22 34.55 22 34V26C22 25.45 22.45 25 23 25H33C33.55 25 34 25.45 34 26V34Z'
          fill='#D4351C'
        />
      </g>
      <defs>
        <clipPath id='clip0_15864_73079'>
          <rect width='24' height='24' fill='white' transform='translate(16 15)' />
        </clipPath>
      </defs>
    </svg>
  )
}
export default UnlockUser
